export default __webpack_public_path__ + "static/media/wallpaper_bg5.d8f5ccaf.jpg";